import { LogoMark } from "./Logo";

export const Footer = () => (
  <footer data-testid="footer" className="border-t border-black/10 bg-coal pb-24 lg:pb-0">
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
      <div className="md:col-span-5">
        <div className="flex items-center gap-3">
          <LogoMark size={26} />
          <span className="font-display text-lg text-pearl">
            North <span className="text-champagne italic">&amp;</span> Noble
          </span>
        </div>
        <p className="mt-5 max-w-sm text-sm text-zinc-500 leading-relaxed">
          The Back-Office Engine. A fully managed front desk, pipeline and booking team for med spas
          and aesthetic clinics. Houston, TX.
        </p>
        <a
          href="mailto:jumi@gonorthnoble.com"
          data-testid="footer-email-link"
          className="mt-5 inline-block font-mono text-sm text-champagne hover:text-champagne-soft transition-colors"
        >
          jumi@gonorthnoble.com
        </a>
      </div>
      <div className="md:col-span-3">
        <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-zinc-400 mb-5">Explore</p>
        <div className="flex flex-col gap-3">
          <a href="#speed-demo" className="text-sm text-zinc-500 hover:text-champagne transition-colors">Speed to Lead</a>
          <a href="#calculator" className="text-sm text-zinc-500 hover:text-champagne transition-colors">Leak Calculator</a>
          <a href="#engine" className="text-sm text-zinc-500 hover:text-champagne transition-colors">The Engine</a>
          <a href="#founder" className="text-sm text-zinc-500 hover:text-champagne transition-colors">The Founder</a>
          <a href="#book" className="text-sm text-zinc-500 hover:text-champagne transition-colors">Book My Audit</a>
          <a href="/contact" className="text-sm text-zinc-500 hover:text-champagne transition-colors">Contact Us</a>
        </div>
      </div>
      <div className="md:col-span-4">
        <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-zinc-400 mb-5">The promise</p>
        <p className="font-display italic text-2xl text-zinc-500 leading-snug">
          "Answered in under five minutes. Worked until it books. Reported in numbers."
        </p>
      </div>
    </div>
    <div className="border-t border-black/10">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-6">
        <p className="font-mono text-[11px] tracking-widest text-zinc-400">
          © 2026 North &amp; Noble · Houston, TX
        </p>
      </div>
    </div>
  </footer>
);
